import { useRef, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { notify } from 'libs/common';
import { GrayButton } from 'libs/ui';
import { PrintersModal } from './ui/printers-modal';
import { Content } from './rack-print.styled';

// let oldPrinting = false;
// let old = false;
export const RackPrint = (props) => {
  const { id, sendControlMsg } = props;
  const [show, setShow] = useState(false);
  const oldRef = useRef(false);
  const timerRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  // console.log('id', id);

  // right
  const right = window.haveRight('mnemo.print_receipt');

  // printer existens on main and other rack -- legacy support
  const with_print_receipt_lagacy = useSelector((store) => store.equipment[id]?.with_print_receipt);

  // p1
  const ready = useSelector((store) => store.equipment[id]?.controller?.sensor_loop_1 === true);

  useEffect(() => {
    const onPrintSuccess = (data) => {
      // console.log('oldRef.current && loading && data.source === id', oldRef.current, loading, id);
      if (oldRef.current && loading && data.source === id && data?.data?.method === 'printer.ticket_print_ok' && data.status === 'processed') {
        notify(t('windows.Внимание'), t('Действие успешно выполнено'), 'success');
        if (timerRef.current) {
          clearTimeout(timerRef.current);
        }
        timerRef.current = null;
        setLoading(false);
      }
    };

    socket.on('add_event', onPrintSuccess);

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
      socket.off('add_event', onPrintSuccess);
    };
  }, [loading, id]);

  // printer existens on main and other rack
  // [
  //   {
  //     name: 'Master',
  //     phone: '111',
  //     sid: null,
  //     type: 'master',
  //     with_print_receipt: true,
  //   },
  //   {
  //     name: 'Sec',
  //     phone: '111',
  //     sid: '00000000000000000000000c29359392',
  //     stream: 'http://10.100.62.111:8888/camera_2.mjpg',
  //     type: 'secondary',
  //     with_print_receipt: false,
  //   },
  // ];
  const instances = useSelector((store) => store.equipment[id]?.instances);
  const activeInstances = instances?.filter((el) => el.with_print_receipt);

  const printLegacy = () => {
    sendControlMsg('print_receipt');
    setLoading(true);
    timerRef.current = setTimeout(() => {
      setLoading(false);
      notify(t('windows.Внимание'), t('Ошибка печати'));
      timerRef.current = null;
    }, 10000);
    // notify(t('windows.Внимание'), t('Действие успешно выполнено'), 'success');
  };

  // old variant
  if (!instances || activeInstances?.length < 2) {
    oldRef.current = true;
    // console.log('print: old');
    const isActive = with_print_receipt_lagacy && right;
    if (!isActive) {
      return null;
    }
    const cl = loading ? 'loading' : '';

    return (
      <GrayButton onClick={printLegacy} className={cl} disabled={!ready}>
        <img src="images/ticket.png" alt="" />
        {t('buttons.Напечатать билет')}
      </GrayButton>
    );
  }

  oldRef.current = false;
  // console.log('print: new');

  // new variant
  const isActive = right;
  if (!isActive) {
    return null;
  }

  /**
   * show popup
   */
  const showPopup = () => {
    // if (!show) {
    setShow(true);
    // }
  };

  /**
   * hide popup
   */
  const hidePopup = () => {
    setShow(false);
  };

  return (
    <Content>
      <GrayButton title="Напечатать билет" onClick={showPopup} disabled={show || !ready}>
        <img src="images/ticket.png" alt="" />
        {t('buttons.Напечатать билет')}
      </GrayButton>
      {show && <PrintersModal close={hidePopup} items={activeInstances} sendControlMsg={sendControlMsg} id={id} />}
    </Content>
  );
};
